export default "__VITE_ASSET__BnkrITru__"